import { createApi } from "@reduxjs/toolkit/query/react";
import {
  mapCountryDetails,
  mapPortDetails,
  mapQuantityDetails,
  maAirlineDetails,
  mapStateMaster,
  mapCityDetails,
  mapGatewayDetails,
  mapVolumeDetails,
  mapCurrencyResponse,
  mapRateMaster,
  mapDesciptionMaster,
  mapHsnCodeMaster,
  mapEndUseCodeMaster,
  mapFTAMaster,
  mapDistrictMaster,
  mapIECodeDetails,
  mapDrawer,
  mapExchangeDetails,
  mapCustomeHouse,
  mapCFSDetails,
  mapAdCodeMaster,
  mapShipLineDetails,
  mapCustomerType,
  mapCustomerDetails,
  mapShipingLine,
  mapEximDetails,
  mapNotation
} from "@/redux/mappers/MasterMapper/MasterMapper";
import { apiurl } from "@/Config/ApiConfig/ApiUrl";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
import { mapEsanchitDocumentType, mapQualifierCode } from "../mappers/MasterMapper/MasterMapper";

export const mastersApi = createApi({
  reducerPath: "shipmentApi",
  baseQuery,
  tagTypes: [
    "Exporter",
    "Ports",
    "Country",
    "Quantity",
    "Airline",
    "ShipmentMain",
    "Gateway",
    "Volume",
    "Currency",
    "CustomHouse",
    "AdCode",
    "ShippingLineMaster",
    "ContactList",
    "ShipingLine",
    "EximCode"
  ],
  endpoints: (builder) => ({
    getPorts: builder.query({
      query: (portType) => {
        const queryString = new URLSearchParams(portType).toString();
        return {
          url: `/shipment/portMaster?${queryString}`,
          method: "GET",
        };
      },
      transformResponse: (response) => {
        return response?.data?.map(mapPortDetails);
      },
      providesTags: ["Ports"],
    }),

    getCountry: builder.query({
      query: () => apiurl.GetCountry,
      transformResponse: (response) => {
        return response?.data?.map(mapCountryDetails);
      },
      providesTags: ["Country"],
    }),

    getState: builder.query({
      query: (countryId) => `/master/state/${countryId}`, // <- add slash
      transformResponse: (response) => {
        return response?.data?.map(mapStateMaster);
      },
      providesTags: ["State"],
    }),

    getStateMaster: builder.query({
      query: () => apiurl.GetState, // <- add slash
      transformResponse: (response) => {
        return response?.data?.map(mapStateMaster);
      },
      providesTags: ["State"],
    }),

    getCityMaster: builder.query({
      query: () => apiurl.GetCity, // <- add slash
      transformResponse: (response) => {
        return response?.data?.map(mapCityDetails);
      },
      providesTags: ["City"],
    }),

    getCity: builder.query({
      query: (stateId) => `/master/city/state/${stateId}`,
      transformResponse: (response) => {
        return response?.map(mapCityDetails);
      },
      providesTags: ["City"],
    }),

    getGateway: builder.query({
      query: () => `/shipment/gateway`,
      transformResponse: (response) => {
        return response?.data?.map(mapGatewayDetails);
      },
      providesTags: ["Gateway"],
    }),

    getAirline: builder.query({
      query: () => apiurl.GetAirline,
      transformResponse: (response) => {
        const transformed = response?.data?.map(maAirlineDetails) || [];

        return transformed;
      },
      providesTags: ["Airline"],
    }),

    getQuantity: builder.query({
      query: () => apiurl.GetQuantity,
      transformResponse: (response) => {
        return response?.data?.map(mapQuantityDetails);
      },
      providesTags: ["Quantity"],
    }),

    getVolume: builder.query({
      query: () => apiurl.GetVolume,
      transformResponse: (response) => {
        return response?.data?.map(mapVolumeDetails);
      },
      providesTags: ["Volume"],
    }),

    getRateListMaster: builder.query({
      query: () => apiurl.GetRateListMaster,
      transformResponse: (response) => {
        return response?.data?.map(mapRateMaster);
      },
      providesTags: ["productGeneral"],
    }),

    // 🔹 Get Description Master
    getDescription: builder.query({
      query: () => apiurl.GetDescription,
      transformResponse: (response) => {
        return response?.data?.map(mapDesciptionMaster);
      },
      providesTags: ["Description"],
    }),

    getHsnCodeMaster: builder.query({
      query: () => apiurl.GetHsnCodeMaster,
      transformResponse: (response) => {
        return response?.data?.map(mapHsnCodeMaster);
      },
      providesTags: ["Description"],
    }),

    getEndUseCodeMaster: builder.query({
      query: () => apiurl.GetEndUseCodeMaster,
      transformResponse: (response) => {
        return response?.data?.map(mapEndUseCodeMaster);
      },

      providesTags: ["productGeneral"],
    }),

    getFTAMaster: builder.query({
      query: () => apiurl.GetFTAMaster,

      transformResponse: (response) => {
        return response?.data?.map(mapFTAMaster);
      },
      providesTags: ["productGeneral"],
    }),

    //district master

    getDistrictMaster: builder.query({
      query: () => apiurl.GetDistrictMaster,

      transformResponse: (response) => {
        return response?.data?.map(mapDistrictMaster);
      },
      providesTags: ["productGeneral"],
    }),

    getIECode: builder.query({
      query: () => apiurl.GetIECode,
      transformResponse: (response) => {
        return response?.data?.map(mapIECodeDetails);
      },
      providesTags: ["IECode"],
    }),

    getCustomer: builder.query({
      query: () => {
        console.log("➡️ Fetching Customer API:", apiurl.GetCustomer);
        return apiurl.GetCustomer;
      },

      transformResponse: (response) => {
        console.log("📌 Raw response:", response);

        const mapped = response?.data?.data?.map(mapCustomerDetails);

        console.log("📝 After mapping:", mapped);

        return mapped;
      },

      providesTags: ["Customer"],
    }),

    getDrawer: builder.query({
      query: () => apiurl.GetDrawer,
      transformResponse: (response) => {
        return response?.data?.map(mapDrawer);
      },
      providesTags: ["Drawer"],
    }),

    getExchange: builder.query({
      query: () => apiurl.GetExchange,
      transformResponse: (response) => {
        return response?.data?.map(mapExchangeDetails);
      },
      providesTags: ["Exchange"],
    }),

    // 🔹 Currency API
    getCurrencies: builder.query({
      query: () => "master/currency",
      transformResponse: (response) => {
        const res = mapCurrencyResponse(response?.data ?? []);
        return res;
      },
      providesTags: ["Currency"],
    }),

    getAdCodeMaster: builder.query({
      query: () => `master/adCode`,
      transformResponse: (response) => {
        const res = response?.map(mapAdCodeMaster);
        return res;
      },
      providesTags: ["AdCode"],
    }),
    //mapCustomeHouse
    getCustomeHouse: builder.query({
      query: () => apiurl.GetCustomeHouse,
      transformResponse: (response) => {
        return response?.data?.map(mapCustomeHouse);
      },
      providesTags: ["CustomHouse"],
    }),

    getInvoiceMaster: builder.query({
      query: ({ exporterMasterId }) =>
        `/export/invoice/main/${exporterMasterId}`,

      transformResponse: (response) => {
        console.log("📌 Raw Invoice Master response:", response);
        return response?.data?.map(mapInvoiceMain);
      },

      providesTags: ["InvoiceMaster"],
    }),

    getCustomehouse: builder.query({
      query: () => "/master/customHouse",
      transformResponse: (response) => {
        const res = mapCustomehouseResponse(response);
        return res;
      },
      providesTags: ["Currency"],
    }),

    getCFS: builder.query({
      query: () => apiurl.GetCFS,
      transformResponse: (response) => {
        return response?.data?.map(mapCFSDetails);
      },
      providesTags: ["CFS"],
    }),

    getShiplineMaster: builder.query({
      query: () => `/shipment/shippingLineMaster`,
      transformResponse: (response) => {
        return response?.data.map(mapShipLineDetails);
      },
      providesTags: ["ShippingLineMaster"],
    }),

    getCustomertypeMaster: builder.query({
      query: () => `/master/customerUserType`,
      transformResponse: (response) => {
        return response?.data.map(mapCustomerType);
      },
      providesTags: ["CustomerTypeMaster"],
    }),

    //mapShipingLine /v1/shipment/shippingLineMaster
    getShipingLine: builder.query({
      query: () => `/shipment/shippingLineMaster`,
      transformResponse: (response) => {
        return response?.data.map(mapShipingLine);
      },
      providesTags: ["ShipingLine"],
    }),
    getFilterHsnCode: builder.query({
      query: (searchText) => ({
        url: "/master/hsnCode",
        params: { hsCode: searchText },
        method: "GET",
      }),

      transformResponse: (response) => {
        console.log("📌 Raw API response:", response);
        return response?.data?.map(mapHsnCodeMaster);
      },
      providesTags: ["HsnCodeMaster"],
    }),
    getQualifierCode: builder.query({
      query: ({ type }) => {
        return {
          url: `/master/QualifierCode?type=${type}`,
          method: "GET",
        };
      },
      transformResponse: (response) => {
        return response?.data?.map(mapQualifierCode);
      },
      providesTags: ["QualifierCode"],
    }),

    getEximCode: builder.query({
      query: () => ({
        url: `/master/scheme`,
        method: "GET",
      }),
      transformResponse: (response) => {
        return response?.data?.map(mapEximDetails);
      },
      providesTags: ["EximCode"],
    }),
    getESanchitDocument : builder.query({
       query: () => `/master/eSanchitDocument`,
      transformResponse: (response) => {
        return response?.data.map(mapEsanchitDocumentType);
      },
      providesTags: ["CustomerTypeMaster"],
      
    }),
    getNotation : builder.query({
      query: () => `/master/notation`,
     transformResponse: (response) => {
       return response?.data.map(mapNotation);
     },
     providesTags: ["NotationMaster"],
     
   })
  }),
});

export const {
  useGetCFSQuery,
  useGetEximCodeQuery,
  useLazyGetEximCodeQuery,
  useGetPortsQuery,
  useGetCountryQuery,
  useGetQuantityQuery,
  useGetGatewayQuery,
  useGetAirlineQuery,
  useGetStateQuery,
  useGetStateMasterQuery,
  useGetCityQuery,
  useGetVolumeQuery,
  useGetExchangeQuery,
  useGetRateListMasterQuery,
  useGetDescriptionQuery,
  useGetHsnCodeMasterQuery,
  useGetEndUseCodeMasterQuery,
  useGetFTAMasterQuery,
  useGetDistrictMasterQuery,
  useGetIECodeQuery,
  useGetCustomerQuery,
  useGetDrawerQuery,
  useGetCurrenciesQuery,
  useGetCityMasterQuery,
  useGetCustomeHouseQuery,
  useGetExchangeMasterIdQuery,
  useGetAdCodeMasterQuery,
  useGetShiplineMasterQuery,
  useGetCustomertypeMasterQuery,
  useGetInvoiceMasterQuery,
  useGetContactListQuery,
  useGetShipingLineQuery,
  useGetFilterHsnCodeQuery,
  useGetQualifierCodeQuery,
  useLazyGetQualifierCodeQuery,
  useGetESanchitDocumentQuery,
  useGetNotationQuery,
} = mastersApi;
